import React from 'react'
import { Box, Container, Grid, Paper, Typography } from '@mui/material'
import { useTranslation } from 'next-i18next'
import ResponsiveButton from '@components/ResponsiveButton'

function GetInTouch() {
  const { t } = useTranslation(['help-center'])

  return (
    <Box pb={12}>
      <Container maxWidth="xl">
        <Paper sx={{ p: { xs: 3, md: 7 } }}>
          <Grid
            container
            spacing={1}
            justifyContent="space-between"
          >
            <Grid
              item
              xs={12}
              md
            >
              <Typography
                variant="body2"
                fontWeight={600}
                display="block"
                gutterBottom
              >
                {t('help-center:Still_have_questions')}
              </Typography>
              <Typography
                variant="body2"
                display="caption"
                sx={{ fontSize: '15px !important' }}
                gutterBottom
              >
                {t('help-center:Can_t_find_the_answer_you_re_looking_for')}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              md="auto"
            >
              <ResponsiveButton
                variant="contained"
                disableElevation
              >
                {t('help-center:get_in_touch')}
              </ResponsiveButton>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Box>
  )
}

export default GetInTouch
